import { makeAutoObservable } from 'mobx';
import { validateGreenToRedPositions } from './validateGreenToRedPositions';

export class GreenToRedPositionsData {
  inRightDirectionPct = 0;
  retracePct = 0;
  pnlTracking = 'unrealized';

  constructor(initialData) {
    makeAutoObservable(this);
    if (initialData) {
      Object.keys(initialData).forEach((field) => {
        if (field === 'inRightDirectionPct' || field === 'retracePct') {
          this[field] = Number(initialData[field]) * 100;
        } else {
          this[field] = initialData[field];
        }
      });
    }
  }

  //common methods
  resetToDefaults = () => {
    this.inRightDirectionPct = 0;
    this.retracePct = 0;
    this.pnlTracking = 'unrealized';
  };
  updateTactic = (dataObj) => {
    for (const key in dataObj) {
      this[key] = dataObj[key];
    }
  };
  validate = () => {
    const data = {
      inRightDirectionPct: this.inRightDirectionPct,
      retracePct: this.retracePct,
      pnlTracking: this.pnlTracking,
    };
    const result = validateGreenToRedPositions(data);
    return result;
  };
  returnJson = () => {
    return {
      inRightDirectionPct: Number(this.inRightDirectionPct) / 100,
      retracePct: Number(this.retracePct) / 100,
      pnlTracking: this.pnlTracking,
    };
  };

  //specific methods
  setInRightDirectionPct = (number) => {
    this.inRightDirectionPct = number;
  };
  setRetracePct = (number) => {
    this.retracePct = number;
  };
  setPnlTracking = (string) => {
    this.pnlTracking = string;
  };
}
